module.exports = __webpack_public_path__ + "img/membercard-purple.29467e39.svg";